import { render } from "./MfDetailManagerRowTab.vue?vue&type=template&id=12ca1eb2"
import script from "./MfDetailManagerRowTab.vue?vue&type=script&lang=js"
export * from "./MfDetailManagerRowTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__